import MonetaryUtils from "../../../shared/utils/MonetaryUtils";
import { hasValue } from "../../utils/pacto-rebates-utils";
import { isValidPercentageNumber } from "./admin-utils";

export const getNetSalesSegmentationId = values => {
	return values.idSegmentation || values.segmentation;
};

export const getNetSalesSegmentationName = values => {
	return values.segmentationName || values.identificacaoSegmentacao;
};

export const formatNetSalesPayload = ({
	growth,
	discount,
	segmentationName,
	identificacaoSegmentacao
}) => {
	return {
		percentualCrescimento: MonetaryUtils.parseDecimal(growth),
		percentualDesconto: MonetaryUtils.parseDecimal(discount),
		identificacaoSegmentacao: segmentationName || identificacaoSegmentacao
	};
};

export const formatNetSalesResponse = netSales => ({
	id: netSales.id,
	idSegmentation: netSales.idSegmentacao || "",
	segmentation: netSales.identificacaoSegmentacao || "",
	growth: netSales.percentualCrescimento,
	discount: netSales.percentualDesconto,
	createdAt: netSales.dataCriacao,
	updatedAt: netSales.dataUltimaAtualizacao
});

export const validateNetSalesPayload = values => {
	const errors = {};
	const segmentationId = getNetSalesSegmentationId(values);

	if (!hasValue(segmentationId)) {
		errors.segmentation = "Informe o tamanho do cliente.";
	} else if (!hasValue(getNetSalesSegmentationName(values))) {
		errors.segmentation = "Não foi possível identificar o nome do tamanho do cliente.";
	}

	if (!hasValue(values.growth)) {
		errors.growth = "Informe a meta de crescimento.";
	} else if (!isValidPercentageNumber(values.growth)) {
		errors.penalty = "O percentual de crescimento deve ter até 5 casas, sendo até 2 decimais.";
    } else if (MonetaryUtils.parseDecimal(values.growth) <= 0) {
        errors.penalty = "O percentual de crescimento deve ser maior que zero.";
    }

	if (!hasValue(values.discount)) {
		errors.discount = "Informe o percentual de desconto.";
	} else if (!isValidPercentageNumber(values.discount)) {
		errors.penalty = "O percentual de desconto deve ter até 5 casas, sendo até 2 decimais.";
    }

	return errors;
};